import React from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "../../lib/api";

export default function AuthLayout({ title, eyebrow, subtitle, children, footer }) {
    return (
        <div className="min-h-screen grid grid-cols-1 lg:grid-cols-12 bg-ivory">
            <div className="hidden lg:flex lg:col-span-5 relative items-center justify-center bg-maroon-900 text-ivory overflow-hidden">
                <img
                    src={ASSETS.poster}
                    alt="Gurukula"
                    className="absolute inset-0 w-full h-full object-cover opacity-30"
                />
                <div className="relative z-10 px-12 max-w-md">
                    <Link to="/" className="flex items-center gap-3 mb-12">
                        <img src={ASSETS.logo} alt="Logo" className="h-12 w-12 rounded-full ring-1 ring-gold/40" />
                        <div className="font-display text-xl">
                            Shri Vishwa Bandhu
                            <span className="block italic text-gold-300 text-base">Sangeetha Gurukula</span>
                        </div>
                    </Link>
                    <h2 className="font-display text-4xl text-ivory leading-tight">
                        Step into a tradition
                        <span className="italic text-gold-300 block">that began with a single swara.</span>
                    </h2>
                    <p className="text-kannada text-lg text-gold-300 mt-8 leading-relaxed">
                        ಸಂಗೀತ ಕೇಳುವುದು ಕಲೆ, ಅನುಭವಿಸುವುದು ಧ್ಯಾನ.
                    </p>
                    <p className="font-serif italic mt-2 text-ivory/80">
                        “Listening to music is an art; experiencing it is meditation.”
                    </p>
                </div>
            </div>

            <div className="lg:col-span-7 flex items-center justify-center p-8 lg:p-16">
                <div className="w-full max-w-md">
                    <Link to="/" className="eyebrow text-gold mb-8 inline-block">
                        ← Back to Gurukula
                    </Link>
                    {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
                    <h1 className="font-display text-4xl text-maroon leading-tight">{title}</h1>
                    {subtitle && (
                        <p className="font-serif text-ink/75 mt-3 leading-relaxed">{subtitle}</p>
                    )}
                    <div className="mt-10">{children}</div>
                    {footer && <div className="mt-8 text-sm font-serif text-ink/75">{footer}</div>}
                </div>
            </div>
        </div>
    );
}
